import api from "../../../api";
import {typedQuery} from "../../typing";

export const regions = typedQuery(["internal", "regions"], async () => {
  return await api.internal.regions.listRegions();
});
